module.exports = __webpack_public_path__ + "img/Rest.e1b9f245.jpeg";